import forEach from 'lodash/forEach';
import isPlainObject from 'lodash/isPlainObject';
export var flattenErrorMessages = function() {
    var errors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, labels = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var result = {};
    var flatten = function(collection) {
        var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
        forEach(collection, function(value, key) {
            var path = "".concat(prefix).concat(key);
            if (isPlainObject(value)) {
                flatten(value, "".concat(path, "."));
            } else if (Array.isArray(value)) {
                for(var i in value){
                    flatten(value[i], "".concat(path, ".").concat(i, "."));
                }
            } else {
                // I had to use a slightly unconventional approach to extract all the nested error
                // messages from react-hook-form. The list of errors uses a naming pattern
                // like "address.city.message" to identify the corresponding input field.
                // To simplify things, I removed the ".message" portion from the pattern and used
                // the resulting value to create a flat list of inputs and
                // their respective error messages.
                if (key === 'message') {
                    path = path.replace(/.message/, '');
                    var _labels_path;
                    result[path] = {
                        label: (_labels_path = labels[path]) !== null && _labels_path !== void 0 ? _labels_path : 'Field',
                        message: value
                    };
                }
            }
        });
    };
    flatten(errors);
    return result;
};
